import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
import ImageSliderEvenement from './carrousselevenements';


const Événements = (props) => {

  return (
    <div>  
            <Header />

    <div id="activites">

      <div className="container">
                   <div className="col-xs-12 col-md-12">
<br></br>
<br></br>

        <div className="section-title">

          <h2 className='evenement'>Événements</h2>
             
        </div>

        <div className="activites-list">
        <h3 style={{ color: "#DF9BA4" }}>Création de décors floraux sur mesure</h3>
        <p>
          J’accompagne particuliers, entreprises et institutions dans la conception et la mise en place de décorations florales élégantes et personnalisées. Chaque projet est pensé avec sensibilité, créativité et exigence du détail afin de sublimer vos moments importants.
        </p>
<br></br>
        
        <h3 style={{ color: "#DF9BA4" }}>Baptêmes, communions et célébrations familiales</h3>

        <p>
          Je conçois des décors floraux doux et symboliques pour accompagner vos célébrations religieuses et familiales : baptêmes, communions, confirmations ou anniversaires.
        </p>

        <p>
          Chaque composition est pensée pour refléter la pureté, la joie et l’émotion de ces moments uniques.
        </p>

        <ul className='lievenements'>
          <li>Centres de table floraux</li>
          <li>Arches fleuries ou décorations festives</li>
          <li>Bouquets et compositions personnalisées</li>
        </ul>
<br></br>

        <h3 style={{ color: "#DF9BA4" }}>Événements privés et réceptions</h3>

        <p>
          Anniversaires, fêtes surprises ou retrouvailles : je crée des ambiances florales chaleureuses et conviviales. Chaque espace est transformé en un lieu vivant et harmonieux grâce à des compositions personnalisées, des guirlandes florales et des bouquets d’accueil.
        </p>
<br></br>

        <h3 style={{ color: "#DF9BA4" }}>Événements professionnels et institutionnels</h3>

        <p>
          J’interviens également pour vos événements d’entreprise et institutionnels : séminaires, conférences, galas, salons, expositions ou cérémonies officielles.
        </p>

        <ul className='lievenements'>
          <li>Mise en scène florale et végétale d’espaces</li>
          <li>Installations florales sur mesure</li>
          <li>Décoration élégante et cohérente avec votre image</li>
        </ul>
<br></br>

      
  <h3 style={{ color: "#DF9BA4" }}>Une signature artistique unique</h3>

        <p>
          Mon approche repose sur l’écoute, la créativité et l’amour du végétal. Chaque projet devient une véritable œuvre florale vivante, pensée pour sublimer vos espaces et marquer les esprits.
        </p>

        <p>
          Je vous accompagne de la conception à la réalisation pour créer une décoration florale à votre image, en parfaite harmonie avec votre événement.
        </p>
<br></br>

          <h3 style={{ color: "#DF9BA4" }}>Collaborations professionnelles</h3>
        <p>
    Je collabore avec des fleuristes, décorateurs, wedding planners collectivités, particuliers et entreprises afin de proposer des prestations florales adaptées aux projets professionnels et aux événements privés ou publics.
        </p>
        <br></br><br></br>
<ImageSliderEvenement />

</div>
      </div>
      </div>
  </div>
      < Footer />

    </div>

  );
};
export default Événements;